// extracted by mini-css-extract-plugin
module.exports = {"resultsNavContainer":"ResultsNavBar_resultsNavContainer__X8tvZ","items":"ResultsNavBar_items__tOn3v","active":"ResultsNavBar_active__22_Lw"};